<template>
  <b-modal
    id="ActivatePromoCode"
    v-model="show"
    size="md"
    hide-footer
    modal-class="main-modal modal-border"
    header-border-variant="0"
    :modal-cancel="emptyResponse"
    centered
    body-class="pt-2"
  >
    <div class="col-12 px-0">
      <div class="no-gutters">
        <h4 class="bold-white-title w-100 text-center mb-5">Активация промокода</h4>
        <b-col class="px-0 mx-0 mx-auto">
          <b-form
            class="form-horizontal px-0 px-lg-3 mx-0" autocomplete="off"
            @submit.prevent="activatePromocode"
          >
            <b-form-group class="mb-4">
              <div class="col-12 px-0">
                <input
                  v-model="payload.promocode"
                  required
                  autocomplete="off"
                  class="main-input form-control"
                  placeholder="Промо код"
                />
              </div>
            </b-form-group>

            <div class="row mx-0 justify-content-between">
              <div class="col-4 px-0">
                <captcha
                  ref="captcha_promocode_activation"
                  :captcha_key="'promocode_activation'"
                  class=""
                />
              </div>
              <div class="col-8 px-0">
                <input
                  v-model="payload.captcha"
                  required
                  class="main-input form-control"
                  placeholder="Код с картинки"
                />
              </div>
            </div>

            <alert :message="response" />
            <div class="form-group row mt-5 mx-0">
              <div class="col-6 col-md-6 text-center text-lg-right mt-md-0 px-2">
                <a class="btn dark-btn mx-auto w-100" @click="closePopup">Отмена</a>
              </div>
              <div class="col-6 col-md-6 px-0 px-md-2">
                <div class="">
                  <button
                    class="btn main-btn w-100"
                    name="submit"
                    :disabled="isSubmitting"
                  >
                    Активировать
                  </button>
                </div>
              </div>
            </div>
          </b-form>
        </b-col>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Alert from '@/components/Alert'
import Captcha from '@/components/main/Captcha'

export default {
  name: 'ActivatePromoCode',
  data () {
    return {
      show: false,
      response: null,
      isSubmitting: false,
      payload: {
        promocode: '',
        captcha: ''
      }
    }
  },
  components: {
    Captcha,
    Alert
  },
  methods: {
    emptyResponse () {
      this.response = null
    },
    closePopup () {
      this.response = null
      this.payload = {
        promocode: '',
        captcha: ''
      }
      this.show = false
    },
    activatePromocode () {
      this.response = { status: 'loading' }
      this.isSubmitting = true
      this.axios.post(
        this.$_config.baseUrl + '/Api/ActivateMyPromoCode/',
        `promocode=${this.payload.promocode}&promocode_activation_captcha=${this.payload.captcha}`,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      ).then(({ data }) => {
        this.response = data
        this.isSubmitting = false
        this.payload.promocode = ''
        this.payload.captcha = ''
        if (data.status !== 'error') {
          setTimeout(() => {
            this.show = false
          }, 3000)
        }
        this.$refs.captcha_promocode_activation.updateCaptcha()
      }).catch(err => {
        if (err) {
          this.$refs.captcha_promocode_activation.updateCaptcha()
          this.response = { status: 'error', msg: err.msg }
          this.isSubmitting = false
        }
      })
    }
  }
}
</script>

<style>
  .bold-white-title{
    color:#ffffff !important;
    font-size: 24px;
    font-weight: 600;
  }
  .modal-header .close {
    margin: 0 !important;
  }
  .modal-header .close{
    margin: 0 !important;
    padding: 0 !important;
    position: absolute;
    right: 10px;
    top: 10px;
    color: #949292;
  }
</style>
